import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { CDN_URL, formatMoney } from "../Helpers";
import { MdLocalShipping, MdStar, MdVerified } from "react-icons/md";
import {
  STR_CROPS,
  STR_LIVESTOCK
} from "../Strings";

export default function View({ data }) {

  const appContext = useContext(AppContext);
  const [loading, setLoading] = useState(false);

  function view() {
    appContext.navTo({
      item: 'view',
      subItem: 'item',
      extraItem: data.uuid,
    })
  }

  const img = (data && (data.img1 || data.img2 || data.img3)) ? (CDN_URL + (data.img1 || data.img2 || data.img3)) : "";

  const categoryLabel = (data.category === "crop")
    ? STR_CROPS[appContext.language]
    : STR_LIVESTOCK[appContext.language];

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
    return () => appContext.setShowOverlayLoader(false);
  }, [loading])

  return (
    <div
      onClick={view}
      style={{
        width: "100%",
        marginBottom: "18px",
        cursor: "pointer",
        borderRadius: "16px",
        overflow: "hidden",
        background: "var(--surfaceColor)",
        boxShadow: "0 10px 28px rgba(0,0,0,0.10)",
        transition: "transform 0.18s ease, box-shadow 0.18s ease",
        border: "1px solid rgba(0,0,0,0.06)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 14px 36px rgba(0,0,0,0.14)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0px)";
        e.currentTarget.style.boxShadow = "0 10px 28px rgba(0,0,0,0.10)";
      }}
      onMouseDown={(e) => {
        e.currentTarget.style.transform = "scale(0.985)";
      }}
      onMouseUp={(e) => {
        e.currentTarget.style.transform = "translateY(0px)";
      }}
    >

      {/* Image */}
      <div
        style={{
          width: "100%",
          height: "210px",
          position: "relative",
          background: "rgba(0,0,0,0.04)",
        }}
      >
        {
          (img) ?
          <img
            src={img}
            alt={data.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
              transform: "scale(1.02)",
            }}
          />
          :
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
              color: "rgba(0,0,0,0.5)",
            }}
            className="font-semi-bold"
          >
            No image
          </div>
        }

        {/* Soft bottom fade like ecommerce cards */}
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            height: "80px",
            background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.55) 100%)",
          }}
        />

        {/* Category chip */}
        <div
          style={{
            position: "absolute",
            top: "12px",
            left: "12px",
            padding: "6px 10px",
            borderRadius: "999px",
            fontSize: "12px",
            background: "rgba(255,255,255,0.92)",
            border: "1px solid rgba(0,0,0,0.08)",
            color: "rgba(0,0,0,0.75)",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            backdropFilter: "blur(8px)",
          }}
          className="font-semi-bold"
        >
          <MdVerified style={{ fontSize: "16px", color: "var(--primaryColor)" }} />
          {data.category}
        </div>

        {/* Discount-style corner (AliExpress feel) */}
        <div
          style={{
            position: "absolute",
            top: "0px",
            right: "0px",
            padding: "10px 12px",
            borderBottomLeftRadius: "14px",
            background: "linear-gradient(135deg, #ff3b30 0%, #ff8a00 100%)",
            color: "#fff",
            fontSize: "11px",
            letterSpacing: "0.4px",
            boxShadow: "0 10px 22px rgba(255,59,48,0.25)",
          }}
          className="font-bold"
        >
          HOT
        </div>

        {/* Bottom mini-row */}
        <div
          style={{
            position: "absolute",
            left: "12px",
            right: "12px",
            bottom: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            color: "rgba(255,255,255,0.92)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "12px",
            }}
            className="font-semi-bold"
          >
            <MdLocalShipping style={{ fontSize: "16px" }} />
            Delivery supported
          </div>

          {/* Fake rating (visual only) */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "12px",
            }}
            className="font-semi-bold"
          >
            <MdStar style={{ fontSize: "16px" }} />
            4.8
          </div>
        </div>

      </div>

      {/* Content */}
      <div
        style={{
          padding: "12px 14px 14px 14px",
        }}
      >

        {/* Title (2 lines like ecommerce) */}
        <div
          style={{
            fontSize: "14px",
            lineHeight: "1.35",
            color: "var(--onSurfaceColor)",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minHeight: "38px",
          }}
          className="font-semi-bold"
        >
          {data.title}
        </div>

        {/* Price row */}
        <div
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
            gap: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              gap: "6px"
            }}
          >
            <span
              style={{
                fontSize: "20px",
                color: "#ff3b30",
              }}
              className="font-bold"
            >
              {formatMoney(data.unitPrice)}
            </span>

            <span
              style={{
                fontSize: "12px",
                color: "rgba(0,0,0,0.55)",
              }}
              className="font-semi-bold"
            >
              TZS
            </span>
          </div>

          <div
            style={{
              fontSize: "12px",
              color: "rgba(0,0,0,0.60)",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              whiteSpace: "nowrap"
            }}
            className="font-semi-bold"
          >
            / {data.unit || 'unit'}
          </div>
        </div>

        {/* CTA row */}
        <div
          style={{
            marginTop: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "rgba(0,0,0,0.55)",
            }}
            className="font-semi-bold"
          >
            Tap to view details
          </div>

          <div
            style={{
              padding: "8px 12px",
              borderRadius: "999px",
              background: "var(--primaryColor)",
              color: "var(--onPrimaryColor)",
              fontSize: "12px",
              boxShadow: "0 10px 22px rgba(0,0,0,0.10)",
              whiteSpace: "nowrap"
            }}
            className="font-bold"
          >
            Order Now
          </div>
        </div>

      </div>

    </div>
  )
}
